/**
 * Created by tigran on 18.01.25
 **/

import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const HelpIcon: FC<IconType> = (props) => {
  const { width, height, color } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 10 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.92857 2.56788C4.92679 2.12681 6.21857 2.17895 6.66 2.89324C7.10107 3.60717 6.79679 4.43752 6.04036 5.0786C5.28393 5.71967 5 6.06753 5 6.57145"
        stroke={color}
        strokeWidth="0.857143"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M4.99999 9.07143C5.29586 9.07143 5.53571 8.83158 5.53571 8.53571C5.53571 8.23985 5.29586 8 4.99999 8C4.70413 8 4.46428 8.23985 4.46428 8.53571C4.46428 8.83158 4.70413 9.07143 4.99999 9.07143Z"
        fill={color}
      />
    </svg>
  );
};
